import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2569e804"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = ["v-show"];
var _hoisted_2 = {
  "class": "LoaderComponent"
};
var _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"container\" data-v-2569e804><div class=\"ball\" data-v-2569e804></div><div class=\"ball\" data-v-2569e804></div><div class=\"ball\" data-v-2569e804></div><div class=\"ball\" data-v-2569e804></div><div class=\"ball\" data-v-2569e804></div><div class=\"ball\" data-v-2569e804></div><div class=\"ball\" data-v-2569e804></div></div>", 1);
var _hoisted_4 = {
  "class": "logo__container"
};
var _hoisted_5 = {
  "class": "logo__cognitive"
};
var _hoisted_6 = {
  "class": "logo__ai"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    "class": "LoaderComponent__container",
    "v-show": !_ctx.hideLoader
  }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.largeText), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.smallText), 1)])])], 8, _hoisted_1);
}